import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { getInspectorAdminWorkTypes } from "requests/inspectorAdminWorkLogs";
import {DATA_TYPE_DATE_TIME, DATA_TYPE_DROPDOWN2, DATA_TYPE_MULTI_LINE_STRING, DATA_TYPE_NUMBER } from "typeConstants/dataTypes";
import MCard, { KeyValueOriginal, MCardField } from "../MCard";

const employeeWorkTypes = [
  {
    label: "Training",
    value: "TRAINING",
  },
  {
    label: "Other",
    value: "OTHER",
  }
];

interface WorkItem {
    startDateTimeLocal: Date,
    timeMinutes: number,
    workType: { code: string },
    note: string,
    milesDriven: number;
};

const AddEditAdminTimeLogForm = props => {
  const [currentWorkItem, setCurrentWorkItem] = useState<WorkItem>(props.currentWorkItem);
  const [workTypeOptions, setWorkTypeOptions] = useState(employeeWorkTypes);

  let mounted = useRef(true);

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  },[]);

  useEffect(() => {
    if (props.inspectorNumber) {
      getInspectorAdminWorkTypes(props.inspectorNumber, data => setWorkTypeOptions(data.map(i => ({
        label: i.name,
        value: i.code
      }))), mounted);
    }
  }, [props.inspectorNumber]);

  const onSaveTimeLog = () => props.onSave(currentWorkItem);

  const fields: MCardField[] = [
    { key: "startDate", label: "Start Date / Time", dataType: DATA_TYPE_DATE_TIME, value: currentWorkItem?.startDateTimeLocal },
    { key: "time", label: "Work Minutes", dataType: DATA_TYPE_NUMBER, value: currentWorkItem?.timeMinutes },
    { key: "miles", label: "Miles Driven (optional)", dataType: DATA_TYPE_NUMBER, value: currentWorkItem?.milesDriven },
    { key: "workType", label: "Work Type*", dataType: DATA_TYPE_DROPDOWN2, value: currentWorkItem?.workType?.code, dataTypeOptions: { options: workTypeOptions } },
    { key: "note", label: "Note*", dataType: DATA_TYPE_MULTI_LINE_STRING, value: currentWorkItem?.note },
    { key: "buttons", control: (
      <div className="admin-work-item-button-container">
        <Button onClick={onSaveTimeLog}>Save</Button>
        <Button onClick={props.onCancel}>Cancel</Button>
      </div>
    ) },
  ];

  const onCardChange = (data: KeyValueOriginal[]) => {
    let newWorkItem = { ...currentWorkItem };
    data.forEach(d => {
      switch (d.key) {
        case "startDate":
          newWorkItem.startDateTimeLocal = d.value;
          break;
        case "time":
          if (d.value > 0) {
            newWorkItem.timeMinutes = d.value, 0;
          }
          break;
        case "miles":
          newWorkItem.milesDriven = Math.max(d.value, 0);
          break;
        case "workType":
          newWorkItem.workType = { ...currentWorkItem.workType, code: d.value };
          // newWorkItem.workType = { code: d.value };
          break;
        case "note":
          newWorkItem.note = d.value;
          break;
      }
    });

    setCurrentWorkItem(newWorkItem);
  };

  return (
    <MCard
      className="admin-timelog-dialog-content"
      title={props.title}
      fields={fields}
      onlyEditable
      onEditChanged={data => onCardChange(data)}
    />
  );
};

AddEditAdminTimeLogForm.propTypes = {
  title: PropTypes.string,
  currentWorkItem: PropTypes.object,  // Admin work log object to add or edit
  minPayPeriodDate: PropTypes.object, // Min date of pay period for this work item
  MaxPayPeriodDate: PropTypes.object, // Max date of pay period for this work item
  onSave: PropTypes.func, // Function to call with form data
  onCancel: PropTypes.func, // Function to call to close dialog
  inspectorNumber: PropTypes.number,  // Only provide if using for FR, this will show mileage field and get FR specific work types
};

export default AddEditAdminTimeLogForm;
